import Home from "./pages/Home/Home";
import Reservations from "./pages/Reservations";
import Contact from "./pages/Contact";
import PrivateParties from "./pages/PrivateParties";
import Layout from "./components/Layout";

import { createBrowserRouter } from "react-router-dom";
import Menu from "./pages/Menu";
import AboutUs from "./pages/AboutUs";
import AboutFood from "./pages/AboutFood";
import AboutBar from "./pages/AboutBar";
import { ExternalAppOpener } from "./components/ExternalAppOpener/ExternalAppOpener";

export const router = createBrowserRouter([
  {
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/about/us",
        element: <AboutUs />,
      },
      {
        path: "/about/our-food",
        element: <AboutFood />,
      },
      {
        path: "/about/our-bar",
        element: <AboutBar />,
      },
      {
        path: "/menu/:section",
        element: <Menu />,
      },
      {
        path: "/reservations",
        element: <Reservations />,
      },
      {
        path: "/private-parties",
        element: <PrivateParties />,
      },
      {
        path: "/contact",
        element: <Contact />,
      },
      {
        path: "/admin",
        element: (
          <ExternalAppOpener url={`${process.env.REACT_APP_API_URL}/_/`} />
        ),
      },
    ],
  },
]);
